import { Images } from '../../../../../../shared/app-constants';


export const COUNTRY_ISO_FLAG_MAP: Record<string, string> = {
  US: Images.USAFlag,
  CA: Images.CanadaFlag,
  GB: Images.UKFlag,
  FR: Images.FranceFlag,
  DE: Images.GermanyFlag,
  BE: Images.BelgiumFlag,
};

export const PHONE_TYPE_OPTIONS = [
  {
    key: 'local',
    value: 'Local',
  },
  {
    key: 'mobile',
    value: 'Mobile',
  },
];

export const customStyles = {
      input: (base: any) => ({
      ...base,
      margin: 0,
      padding: 0,
      fontSize: '14px',
    }),
};
  // {

  //   input: (base: any) => ({
  //     ...base,
  //     margin: 0,
  //     padding: 0,
  //     fontSize: '14px',
  //   }),
  //   singleValue: (base: any) => ({
  //     ...base,
  //     fontSize: '14px',
  //     color: '#1F2937',
  //     margin: 0,
  //   }),
  //   menu: (base: any) => ({
  //     ...base,
  //     marginTop: '4px',
  //     borderRadius: '4px',
  //     border: '1px solid #E5E7EB',
  //     boxShadow: '0 2px 8px rgba(0, 0, 0, .15)',
  //     zIndex: 9999,
  //   }),
  //   menuList: (base: any) => ({
  //     ...base,
  //     padding: '8px 0px',
  //     maxHeight: '224px',
  //   }),
  //   option: (base: any, state: any) => ({
  //     ...base,
  //     fontSize: '14px',
  //     lineHeight: '20px',
  //     color: '#1F2937',
  //     padding: '6px 12px',
  //     backgroundColor: state.isFocused ? '#EFF6FF' : 'white',
  //     cursor: 'pointer',
  //     '&:active': {
  //       backgroundColor: '#EFF6FF',
  //     },
  //   }),
  //   indicatorSeparator: () => ({
  //     display: 'none',
  //   }),
  //   dropdownIndicator: () => ({
  //     display: 'none',
  //   }),
  // }

